import Page from "components/Page";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const UserPools = lazyWithRetry(() => import("./UserPoolsList"));

export default () => (
  <Page>
    <UserPools />
  </Page>
);
